<template>
 
       <v-card flat olor="#1c1d29" style="margin-top: 20px;">
            <v-toolbar card prominent flat color="#1c1d29">
                <v-toolbar-title>Breakouts ({{total}})</v-toolbar-title>

                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <breakout-admin-create></breakout-admin-create>
                </v-toolbar-items>
            </v-toolbar>    
            <v-card-text>

            
                
                <v-list two-line>


                    <template v-for="breakout in breakouts">
                        <v-list-tile :key="breakout.id" avatar>
                            <v-list-tile-avatar tile>
                                <v-img :src="breakout.image_src" />
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title v-html="breakout.title"></v-list-tile-title>
                                <v-list-tile-sub-title>{{breakout.description}}</v-list-tile-sub-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                    <v-btn
                                    color="red"
                                    @click.prevent="removeBreakout(breakout.id)"
                                    class="ml-0"
                                    icon
                                    >
                                        <v-icon color="white">close</v-icon>
                                    </v-btn>

                            </v-list-tile-action>
                        </v-list-tile>
                    </template>
                </v-list>
                
            </v-card-text>
             <!-- <v-card-actions>
                <v-toolbar card light>
                    Page {{page}} of {{totalPages}}
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="getPrev" v-if="prevPage" icon><v-icon>keyboard_arrow_left</v-icon></v-btn>
                    <v-btn color="blue darken-1" flat @click="getNext" v-if="nextPage" icon><v-icon>keyboard_arrow_right</v-icon></v-btn>
                </v-toolbar>
            </v-card-actions> -->
        </v-card>
 
</template>

<script>
    export default {
        data(){
            return {
                breakouts : [],
                page: 1,
                count: 0,
                total: 0,
                totalPages: 1,
                nextPage: null,
                prevPage: null,
                current_page: '/api/breakouts'
            }
        },
        created(){
            let self = this;

            this.getBreakouts();

             Bus.$on('vmBreakoutsChanged', function(){

                self.getBreakouts();

            })
        },
        mounted() {
            console.log('Breakout List mounted.')
        },
        methods: {

              getNext(){
                this.getBreakouts(this.nextPage);
            },

            getPrev(){
                this.getBreakouts(this.prevPage);
            },


            getBreakouts(url = null) {

                this.loading = true;

                console.log('hello from getBreakouts');

                if(!url){
                    url = this.current_page;
                } else {
                    this.current_page = url;
                }

                axios.get(url).then(res => {

                    console.log(res);
                    this.breakouts = res.data.data;
                    this.page = res.data.current_page;
                    this.total = res.data.total;
                    this.totalPages = res.data.last_page;

                    this.nextPage = res.data.next_page_url;
                    this.prevPage = res.data.prev_page_url;


                });

            },

            removeBreakout(bid){

                var confirm = window.confirm("Are you sure you want to delete this breakout? This action cannot be undone.");

                let self = this;

                if(confirm){

                    var deleteForm = new SparkForm({});
                    Spark.delete('/api/breakouts/' + bid, deleteForm)
                        .then((response) => {

                    Bus.$emit('vmBreakoutsChanged');

                            alert("Breakout deleted.");
                    });

                }

                
            }



        }
    }
</script>

<style scoped>
 
</style>